import React from "react";
import { CreditCard, ExternalLink } from "lucide-react";

export const STRIPE_DONATION_LINK = process.env.REACT_APP_STRIPE_DONATION_LINK;

// General Paws on Record donations only. Rescue-specific gifts go straight
// to each verified rescue's own donation page — never through this link.
export default function StripePaymentLinkButton({ testId = "stripe-payment-link-btn", className = "", dark = false }) {
  if (!STRIPE_DONATION_LINK) return null;
  return (
    <div className={className} data-testid={`${testId}-wrap`}>
      <a
        href={STRIPE_DONATION_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full bg-red-600 hover:bg-red-700 text-white font-bold uppercase tracking-widest text-sm py-4 px-4 flex items-center justify-center gap-2 border-2 border-red-600 transition-colors"
        data-testid={testId}
      >
        <CreditCard size={16} /> Donate with Stripe — any amount <ExternalLink size={13} />
      </a>
      <p className={`text-[11px] mt-2 ${dark ? "text-zinc-300" : "text-zinc-600"} text-center leading-relaxed`}>
        Choose your own amount ($5 suggested) on Stripe's secure page. Card, Apple Pay &amp; Google Pay.
        You'll get an emailed receipt. Supports Paws on Record (not tax-deductible).
      </p>
    </div>
  );
}
